const getURI = contentId => `presentations/v1/deck/${contentId}/share`;
const getInsertContent = ({
  shortLink,
  name
}) => {
  return {
    url: shortLink,
    text: name
  };
};
export function renderDocument({
  httpClient,
  contactEmail,
  contentId,
  requireEmail = true,
  allowDownload = true
}) {
  const skipForm = !requireEmail;
  const promise = httpClient.post(getURI(contentId), {
    query: {
      sharedWith: contactEmail,
      skipForm,
      hasDownload: allowDownload
    }
  }).then(res => {
    return getInsertContent(res);
  }).catch(error => {
    return Promise.reject(error);
  });
  return promise;
}